import { withInstall } from '../../../utils/with-install'
import ControlBar from './ControlBar.vue'

export const ElAmapControlControlBar = withInstall(ControlBar)
export default ElAmapControlControlBar
